// src/hooks/currencies/useDeleteAllCurrencies.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllCurrencies } from "../../api/apiCurrencies";
import { useTranslation } from "react-i18next";

function useDeleteAllCurrencies() {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const { mutate: deleteAllCurrenciesMutation, isPending: isDeleteAll } = useMutation({
        mutationFn: deleteAllCurrencies,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["currencies"] });
            toast.success(isArabic ? "تم حذف العملات المحددة بنجاح" : "Selected currencies deleted successfully");
        },
        onError: (err) => {
            toast.error(err?.message || (isArabic ? "فشل في حذف العملات" : "Failed to delete currencies"));
        },
    });

    return { deleteAllCurrencies: deleteAllCurrenciesMutation, isDeleteAll };
}

export default useDeleteAllCurrencies;
